module.exports = __webpack_public_path__ + "static/home-artist-management-mobile-fa7f91d2b25512af2000d4242edb68dd.webp";